import { LoanPartnerCommunicationOverviewPage } from '@interhyp/module-credit-communication';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { Navigation, NavItems } from '../../navigation/Navigation';

export function InquiryCommunicationOverviewWrapper(): JSX.Element {
  const { inquiryId } = useParams<{ inquiryId: string }>();

  const navigationItems: NavItems = useMemo(() => {
    return [
      { to: `/credit/inquiries/${inquiryId}`, translation: 'navigation.preInquiry' },
      { to: `/credit/inquiries/${inquiryId}/documents`, translation: 'navigation.documents' },
      {
        to: `/credit/inquiries/${inquiryId}/communication`,
        translation: 'navigation.communication',
      },
    ];
  }, [inquiryId]);

  return (
    <>
      <Navigation navItems={navigationItems} />
      <LoanPartnerCommunicationOverviewPage aggregateId={inquiryId} resourceType="PRE_INQUIRY" />
    </>
  );
}
